import { FC } from 'react'
import { Assignee } from './Assignee'
import { ConsultAttorney } from './ConsultAttorney'

const LegalTeam: FC = () => {
  return (
    <>
      {/* Renders itself only for consults; nothing changes for regular matters. */}
      <ConsultAttorney />
      <Assignee />
    </>
  )
}

export default LegalTeam
